<p-stepper [(activeStep)]="activeIndex" [ngClass]="{ 'no-headers': stepAmount() < 2 }">
  @for (step of steps(); track trackStep(step)) {
    <p-stepperPanel>
      <!-- HEADER -->
      <ng-template pTemplate="header" let-index="index" let-active="active" let-highlighted="highlighted">
        <div class="step-header" (click)="updateActiveStep(index)">
          @if (step.title(); as headerTitle) {
            <div class="step-header__title-anchor">
              <span class="step-header__title" [ngClass]="{ 'step-header__title--active': active }">{{
                headerTitle
              }}</span>
            </div>
          }
          <div
            pRipple
            class="step-header__button"
            [ngClass]="{
              'step-header__button--active': active,
              'step-header__button--visited': index <= maxStepIndexVisited()
            }"
          >
            @if (step.icon(); as headerIcon) {
              <osp-icon
                [icon]="headerIcon"
                [iconColor]="active || index <= maxStepIndexVisited() ? 'button-text' : 'text-secondary'"
              ></osp-icon>
            } @else {
              <span>{{ index + 1 }}</span>
            }
          </div>
        </div>
      </ng-template>

      <!-- CONTENT -->
      <ng-template pTemplate="content" let-index="index" let-active="active" let-highlighted="highlighted">
        @if (step.contentTemplate(); as stepTemplate) {
          <ng-container
            [ngTemplateOutlet]="stepTemplate"
            [ngTemplateOutletContext]="
              { index, active, highlighted, isValid: step.isValid() } | stepTemplateContext: this
            "
          ></ng-container>
        }
      </ng-template>
    </p-stepperPanel>
  }
</p-stepper>
@if (steps()?.[activeIndex()]; as step) {
  <div class="stepper-footer" [class.stepper-footer-empty]="steps()!.length < 2">
    <ng-container
      [ngTemplateOutlet]="step.footerTemplate()"
      [ngTemplateOutletContext]="
        {
          index: activeIndex(),
          isValid: step.isValid()
        } | stepTemplateContext: this
      "
    ></ng-container>
  </div>
}
